import { ComponentRef, NgModule, ViewContainerRef } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PortalModule } from '@angular/cdk/portal'

import { SharedHeaderFeatureHeadlessModule } from '@alliance/shared/header/feature-headless'
import { RenderAsLazyService } from '@alliance/shared/utils'
import { ClubsHeaderModule } from '@alliance/clubs/header'

import { LazyHeaderComponent } from './lazy-header.component'

@NgModule({
  imports: [CommonModule, PortalModule, SharedHeaderFeatureHeadlessModule, ClubsHeaderModule],
  declarations: [LazyHeaderComponent],
  exports: [LazyHeaderComponent]
})
export class LazyHeaderModule {
  public constructor(private renderAsLazyService: RenderAsLazyService) {}

  public render(viewContainerRef: ViewContainerRef): ComponentRef<LazyHeaderComponent> {
    return this.renderAsLazyService.render<LazyHeaderComponent>(viewContainerRef, LazyHeaderComponent)
  }
}
